import Vue from 'vue';
import { saveData, getData } from '../../utils/storage';
export default Vue.extend({
    name: 'tooltip',
    data: function () {
        return {
            isShowTemplateUpdateTips: false,
        };
    },
    props: {
        content: {
            type: String,
            default: '请输入提示内容',
        },
        keyName: {
            type: String,
            require: true,
        },
        times: {
            type: Number,
            default: 1,
        },
    },
    mounted: function () {
        // this.initPopover()
    },
    methods: {
        initPopover: function () {
            var _a = this, keyName = _a.keyName, times = _a.times;
            var contractModel = getData(keyName);
            this.isShowTemplateUpdateTips =
                !contractModel || contractModel.popoverVisibleNum < times;
            if (contractModel) {
                saveData(keyName, {
                    popoverVisibleNum: ++contractModel.popoverVisibleNum,
                });
            }
            else {
                saveData(keyName, {
                    popoverVisibleNum: 1,
                });
            }
        },
    },
});
